import { useState } from "react";
import { TriangleAlert } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import DiscrepancyList from "@/components/DiscrepancyList";

const CHIPS = [["damaged", "disc.damaged"], ["missing", "disc.missing"], ["extra", "disc.extra"]];

// Receiving differences as one collapsible band; the full list opens on demand.
export default function DamageBand({ rows, names, actions }) {
  const { t } = useLang();
  const [expanded, setExpanded] = useState(false);
  const open = rows.some(row => row.status === "OPEN");

  return (
    <section className={`overflow-hidden rounded-xl border ${open ? "border-amber-200 bg-amber-50 text-amber-800" : "border-slate-200 bg-slate-50 text-slate-700"}`}
      data-testid="receiver-discrepancies">
      <div className="flex flex-wrap items-center gap-2.5 px-3.5 py-2.5">
        <TriangleAlert className="h-5 w-5 shrink-0" />
        <div className="min-w-48 flex-1">
          <p className="text-sm font-bold">{t("recv.discrepancies_count", { count: rows.length })}</p>
          {open && <p className="text-xs">{t("recv.discrepancy_waiting")}</p>}
        </div>
        <div className="flex flex-wrap gap-1.5">
          {CHIPS.map(([field, key]) => {
            const total = rows.reduce((sum, row) => sum + row[field], 0);
            return total > 0 && (
              <span key={field} className="rounded-full border border-amber-300 bg-white px-2 py-0.5 text-[11.5px] font-bold text-amber-700">{t(key)} {total}</span>
            );
          })}
        </div>
        <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded}
          className="rounded-lg border border-current px-3 py-1 text-xs font-semibold">
          {t(expanded ? "recv.band_hide" : "recv.band_show")}
        </button>
      </div>
      {expanded && (
        <div className="bg-white px-3.5 py-3 text-slate-900">
          <DiscrepancyList rows={rows} names={names} actions={actions} />
        </div>
      )}
    </section>
  );
}
